import React, {Fragment, useState} from 'react';
import {Button, Card, Col, Form, Input, Radio, Row, Select} from 'antd';
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {
  changeELSrcFileForm,
  convertElSrcFileExcel,
  hideElSrcFilePreview,
  pingELConnectionEndpoint,
  readELSrcDataflows,
  readElSrcFilePreview,
  readElSrcTables,
  setElConnectionEndpoint,
  setELSourceFormat,
  setELSrcDataflow,
  setElSrcTable,
  showElSrcFilePreview,
  unsetELSrcDataflow,
  uploadElSrcFileCsv,
  uploadElSrcFileExcel
} from "../actions";
import FileInput from "../../file-input";
import {
  GUTTER_MD,
  MARGIN_MD,
  MODAL_WIDTH_LG,
  SPAN_FULL,
  SPAN_HALF,
  SPAN_ONE_QUARTER,
  SPAN_THREE_QUARTERS
} from "../../../styles/constants";
import EndpointsDropdown from "../../endpoints-dropdown";
import Selector from "../../selector";
import EnhancedModal from "../../enhanced-modal";
import Call from "../../../hocs/call";
import ArtefactList from "../../artefact-list";
import {
  NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_REST
} from "../../../scenes/configuration/nodes-config/node/EndpointForm";
import {getLocalizedStr} from "../../../middlewares/i18n/utils";
import {EL_SOURCE_FORMAT_CSV, EL_SOURCE_FORMAT_DB, EL_SOURCE_FORMAT_SDMX_EP, EL_SOURCE_FORMAT_XLS} from "../constants";
import _ from "lodash";
import InfiniteScrollDataTable from "../../infinite-scroll-data-table";
import {getFilterObjFromViewerObj} from "../../../utils/filter";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  endpoints: state.config.nodes,
  endpointId: state.app.endpointId,
  sourceFormat: state.scenes.easyLoading.sourceFormat,
  connectionEndpointId: state.scenes.easyLoading.connectionEndpointId,
  isConnectionEndpointAvailable: state.scenes.easyLoading.isConnectionEndpointAvailable,
  srcDataflows: state.scenes.easyLoading.srcDataflows,
  srcDataflow: state.scenes.easyLoading.srcDataflow,
  srcFile: state.scenes.easyLoading.srcFile,
  srcFileRows: state.scenes.easyLoading.srcFileRows,
  srcFileRowsVisible: state.scenes.easyLoading.srcFileRowsVisible,
  srcTables: state.scenes.easyLoading.srcTables,
  srcTable: state.scenes.easyLoading.srcTable,
});

const mapDispatchToProps = dispatch => ({
  onFormatSet: format => dispatch(setELSourceFormat(format)),
  onConnectionEndpointSet: endpointId => dispatch(setElConnectionEndpoint(endpointId)),
  onConnectionEndpointPing: endpointId => dispatch(pingELConnectionEndpoint(endpointId)),
  fetchDataflows: endpointId => dispatch(readELSrcDataflows(endpointId)),
  onDataflowSet: dataflow => dispatch(setELSrcDataflow(dataflow)),
  onDataflowUnset: () => dispatch(unsetELSrcDataflow()),
  onChange: fields => dispatch(changeELSrcFileForm(fields)),
  onFileCsvUpload: file => dispatch(uploadElSrcFileCsv(file)),
  onFileExcelUpload: (file, mapping) => dispatch(uploadElSrcFileExcel(file, mapping)),
  onFileExcelConvert: ({filePath, mappingPath}) => dispatch(convertElSrcFileExcel(filePath, mappingPath)),
  onPreviewShow: () => dispatch(showElSrcFilePreview()),
  onPreviewHide: () => dispatch(hideElSrcFilePreview()),
  fetchPreview: (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, csvPath) =>
    dispatch(readElSrcFilePreview(pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, csvPath)),
  fetchTables: () => dispatch(readElSrcTables()),
  onTableSet: (tableName, csvSeparator) => dispatch(setElSrcTable(tableName, csvSeparator)),
});

const mapPropsToFields = ({srcFile}) => ({
  file: Form.createFormField({value: (srcFile && srcFile.file) ? srcFile.file : null}),
  mapping: Form.createFormField({value: (srcFile && srcFile.mapping) ? srcFile.mapping : null}),
  separator: Form.createFormField({value: (srcFile && srcFile.separator) ? srcFile.separator : null}),
  delimiter: Form.createFormField({value: (srcFile && srcFile.delimiter) ? srcFile.delimiter : null})
});

const onFieldsChange = (props, fields) =>
  props.onChange(_.mapValues(fields, ({value}) => value));

const formItemLayout = {
  labelCol: {span: SPAN_ONE_QUARTER},
  wrapperCol: {span: SPAN_THREE_QUARTERS}
};

const ELConnectionStep = ({
                            t,
                            form,
                            appLanguage,
                            dataLanguages,
                            endpoints,
                            endpointId,
                            sourceFormat,
                            connectionEndpointId,
                            isConnectionEndpointAvailable,
                            srcDataflows,
                            srcDataflow,
                            srcFile,
                            srcFileRows,
                            srcFileRowsVisible,
                            srcTables,
                            srcTable,
                            onFormatSet,
                            onConnectionEndpointSet,
                            onConnectionEndpointPing,
                            fetchDataflows,
                            onDataflowSet,
                            onDataflowUnset,
                            onFileCsvUpload,
                            onFileExcelUpload,
                            onFileExcelConvert,
                            onPreviewShow,
                            onPreviewHide,
                            fetchPreview,
                            fetchTables,
                            onTableSet
                          }) => {

  const [isVisible, setVisibility] = useState(false);

  return (
    <Fragment>
      <Card type="inner">
        <Form className="advanced-form">
          <Form.Item
            className="form-item-required"
            label={t('components.easyLoading.steps.connection.body.format.label')}
            style={{marginBottom: MARGIN_MD}}
            {...formItemLayout}
          >
            <Radio.Group
              value={sourceFormat}
              onChange={({target}) => onFormatSet(target.value)}
            >
              <Radio.Button value={EL_SOURCE_FORMAT_CSV}>
                {t('components.easyLoading.steps.connection.body.format.values.csv')}
              </Radio.Button>
              <Radio.Button value={EL_SOURCE_FORMAT_XLS}>
                {t('components.easyLoading.steps.connection.body.format.values.xls')}
              </Radio.Button>
              <Radio.Button value={EL_SOURCE_FORMAT_SDMX_EP}>
                {t('components.easyLoading.steps.connection.body.format.values.sdmxEp')}
              </Radio.Button>
              <Radio.Button value={EL_SOURCE_FORMAT_DB}>
                {t('components.easyLoading.steps.connection.body.format.values.db')}
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
          {(sourceFormat === EL_SOURCE_FORMAT_CSV || sourceFormat === EL_SOURCE_FORMAT_XLS) && (
            <Fragment>
              <Row style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item
                    className="form-item-required"
                    label={t('data.csv.file.label')}
                    {...formItemLayout}
                  >
                    {form.getFieldDecorator('file')(
                      <FileInput
                        accept={sourceFormat === EL_SOURCE_FORMAT_CSV ? ".csv" : ".xls,.xlsx"}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              {sourceFormat === EL_SOURCE_FORMAT_XLS && (
                <Row style={{marginBottom: MARGIN_MD}}>
                  <Col span={SPAN_FULL}>
                    <Form.Item
                      className="form-item-required"
                      label={t('components.easyLoading.steps.connection.body.mapping.label')}
                      {...formItemLayout}
                    >
                      {form.getFieldDecorator('mapping')(
                        <FileInput
                          accept=".xml"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_HALF}>
                  <Form.Item
                    className="form-item-required"
                    label={t('data.csv.separator.label')}
                    labelCol={{span: SPAN_HALF}}
                    wrapperCol={{span: SPAN_HALF}}
                  >
                    {form.getFieldDecorator('separator')(
                      <Input maxLength={1}/>
                    )}
                  </Form.Item>
                </Col>
                <Col span={SPAN_HALF}>
                  <Form.Item
                    label={t('data.csv.delimiter.label')}
                    labelCol={{span: SPAN_HALF}}
                    wrapperCol={{span: SPAN_HALF}}
                  >
                    {form.getFieldDecorator('delimiter')(
                      <Input maxLength={1}/>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row type="flex" justify="center" gutter={GUTTER_MD}>
                <Col>
                  <Form.Item>
                    <Button
                      type="primary"
                      icon="upload"
                      onClick={() => sourceFormat === EL_SOURCE_FORMAT_CSV
                        ? onFileCsvUpload(srcFile.file)
                        : onFileExcelUpload(srcFile.file, srcFile.mapping)
                      }
                      disabled={!srcFile || !srcFile.file || !srcFile.separator || (sourceFormat === EL_SOURCE_FORMAT_XLS && !srcFile.mapping)}
                    >
                      {t('data.csv.uploadButton.label')}
                    </Button>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item>
                    <Button
                      icon="table"
                      onClick={onPreviewShow}
                      disabled={!srcFile || !srcFile.csvPath}
                    >
                      {t('data.csv.tableShowButton.label')}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Fragment>
          )}
          {sourceFormat === EL_SOURCE_FORMAT_SDMX_EP && (
            <Fragment>
              <Row style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item
                    className='form-item-required'
                    label={t('components.easyLoading.steps.connection.body.endpoint.label')}
                    {...formItemLayout}
                  >
                    <EndpointsDropdown
                      endpoints={endpoints.filter(ep => (
                        ep.general.id !== endpointId && (
                          (ep.endpoint.nsiEndpointType === NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_REST)
                        )
                      ))}
                      endpointId={connectionEndpointId}
                      onEndpointSet={onConnectionEndpointSet}
                      onNodePing={() => onConnectionEndpointPing(connectionEndpointId)}
                      isEndpointAvailable={isConnectionEndpointAvailable}
                      doNotGoHome
                      canBeNull
                      fullWidth
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={SPAN_FULL}>
                  <Form.Item
                    className="form-item-required"
                    label={t('components.easyLoading.steps.connection.body.dataflow.label')}
                    {...formItemLayout}
                  >
                    <Call
                      cb={onConnectionEndpointPing}
                      cbParam={connectionEndpointId}
                      disabled={!connectionEndpointId}
                    >
                      <Selector
                        value={srcDataflow}
                        render={dataset => dataset
                          ? getLocalizedStr(dataset.name, appLanguage, dataLanguages)
                          : ""
                        }
                        selectTitle={t('components.easyLoading.steps.connection.body.dataflow.select')}
                        resetTitle={t('components.easyLoading.steps.connection.body.dataflow.reset')}
                        onSelect={() => setVisibility(true)}
                        onReset={onDataflowUnset}
                        disabled={!connectionEndpointId || !isConnectionEndpointAvailable}
                      />
                      {connectionEndpointId && isConnectionEndpointAvailable && (
                        <EnhancedModal
                          visible={isVisible}
                          onCancel={() => setVisibility(false)}
                          title={t('components.easyLoading.steps.connection.body.modals.dataflow.title')}
                          width={MODAL_WIDTH_LG}
                          footer={
                            <Button onClick={() => setVisibility(false)}>
                              {t('commons.buttons.close.title')}
                            </Button>
                          }
                        >
                          <Call
                            cb={fetchDataflows}
                            cbParam={connectionEndpointId}
                            disabled={!isVisible}
                          >
                            <ArtefactList
                              artefacts={srcDataflows || []}
                              onRowClick={dataflow => {
                                onDataflowSet(dataflow);
                                setVisibility(false);
                              }}
                            />
                          </Call>
                        </EnhancedModal>
                      )}
                    </Call>
                  </Form.Item>
                </Col>
              </Row>
            </Fragment>
          )}
          {sourceFormat === EL_SOURCE_FORMAT_DB && (
            <Call
              cb={fetchTables}
              disabled={srcTables !== null}
            >
              <Row style={{marginBottom: MARGIN_MD}}>
                <Col span={SPAN_FULL}>
                  <Form.Item
                    className='form-item-required'
                    label={t('components.easyLoading.steps.connection.body.table.label')}
                    {...formItemLayout}
                  >
                    <Select
                      showSearch
                      value={srcTable}
                      onChange={val => onTableSet(val, srcFile.separator)}
                    >
                      {(srcTables || []).map((table, idx) => (
                        <Select.Option key={idx} value={table}>
                          {table}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row type="flex" justify="center" gutter={GUTTER_MD}>
                <Col>
                  <Form.Item>
                    <Button
                      icon="table"
                      onClick={onPreviewShow}
                      disabled={!srcFile || !srcFile.csvPath}
                    >
                      {t('data.csv.tableShowButton.label')}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Call>
          )}
        </Form>
      </Card>
      <EnhancedModal
        visible={srcFileRowsVisible}
        onCancel={onPreviewHide}
        title={t('components.easyLoading.steps.connection.modals.srcFilePreview.title')}
        width={MODAL_WIDTH_LG}
        footer={<Button onClick={onPreviewHide}>{t('commons.buttons.close.title')}</Button>}
      >
        <InfiniteScrollDataTable
          data={srcFileRows && srcFileRows.Data}
          rowTotal={srcFileRows && srcFileRows.Count}
          cols={srcFileRows && srcFileRows.Columns}
          hiddenCols={['NumRow']}
          onChange={
            ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => fetchPreview(
              pageNum,
              pageSize,
              getFilterObjFromViewerObj(
                srcFileRows && srcFileRows.Columns.filter(colName => colName !== 'NumRow'),
                searchText,
                filters
              ),
              sortCol ? [sortCol] : null,
              sortByDesc,
              srcFile.separator,
              srcFile.delimiter || null,
              true,
              srcFile.csvPath
            )
          }
        />
      </EnhancedModal>
      <Call
        cb={onFileExcelConvert}
        cbParam={{
          filePath: srcFile && srcFile.filePath,
          mappingPath: srcFile && srcFile.mappingPath
        }}
        disabled={!srcFile || !srcFile.filePath || !srcFile.mappingPath || srcFile.csvPath}
      >
        <span/>
      </Call>
    </Fragment>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(ELConnectionStep);


// WEBPACK FOOTER //
// ./src/components/easy-loading/connection-step/index.jsx